import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cartActions } from '../../reducers/storeCart';
import * as types from '../../types';

/**
 * Captures Awin click ID (awc) from URL parameters and stores in Redux.
 * Awin affiliate links include ?awc=xxx to identify the click source.
 * This ID is included in analytics events so the analytics-backend can
 * attribute conversions to the originating affiliate click via S2S API.
 */
export function AwinClickCapture(): null {
  const dispatch = useDispatch();
  const cart = useSelector((state: types.AppState) => state.storeShop.cart);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const awc = urlParams.get('awc');
    if (awc && awc !== cart.awinClick) {
      dispatch(cartActions.setAwinClick(awc));
    }
  }, [dispatch, cart.awinClick]);

  return null;
}
